import { IXetTotNghiepLanXetActionTypes } from "../../action-types/xet-tot-nghiep/IXetTotNghiepLanXetActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IXetTotNghiepLanXetReducer } from "../../reducer-model/xet-tot-nghiep/IXetTotNghiepLanXetReducer";

const iniState: IXetTotNghiepLanXetReducer = {
    status: eReducerStatusBase.is_not_initialization,
    xetTotNghiepLanXets: [],
    isShowEditModal: false,
    xetTotNghiepLanXetEdit: undefined,
}

export const xetTotNghiepLanXetReducer = (state: IXetTotNghiepLanXetReducer = iniState, action: IXetTotNghiepLanXetActionTypes): IXetTotNghiepLanXetReducer => { 
    switch (action.type) {
        case "XET_TOT_NGHIEP_LAN_XET_LOAD_START":
            console.log("🚀 ~ XET_TOT_NGHIEP_LAN_XET_LOAD_START");
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "XET_TOT_NGHIEP_LAN_XET_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                xetTotNghiepLanXets: action.payload,
            };
        case "XET_TOT_NGHIEP_LAN_XET_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "XET_TOT_NGHIEP_LAN_XET_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                xetTotNghiepLanXetEdit: action.payload,
            };
        case "XET_TOT_NGHIEP_LAN_XET_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
                xetTotNghiepLanXetEdit: undefined,
            };
        case "XET_TOT_NGHIEP_LAN_XET_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "XET_TOT_NGHIEP_LAN_XET_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false,
                xetTotNghiepLanXetEdit: undefined,
            };
        case "XET_TOT_NGHIEP_LAN_XET_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "XET_TOT_NGHIEP_LAN_XET_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "XET_TOT_NGHIEP_LAN_XET_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "XET_TOT_NGHIEP_LAN_XET_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "XET_TOT_NGHIEP_LAN_XET_UPDATE_LOCK_STATUS_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "XET_TOT_NGHIEP_LAN_XET_UPDATE_LOCK_STATUS_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "XET_TOT_NGHIEP_LAN_XET_UPDATE_LOCK_STATUS_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    } 

}